import React from 'react';
import { connect } from 'react-redux';

import { DatePicker } from 'redpoints-front-components/index';
import { getDefaultDateRanges } from 'redpoints-front-common/helpers';

import { allIncidentsFiltersSetConfirmationDate } from '../../../actions/allIncidentsActions';
import { getAllIncidentsFiltersConfirmationDate } from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsFiltersConfirmationDate = ({
  allIncidentsFiltersSetConfirmationDate,
  confirmationDate,
}) => {
  const handlerSetConfirmationDate = confirmationDate =>
    allIncidentsFiltersSetConfirmationDate({ confirmationDate });

  return (
    <DatePicker
      label={translate(
        'reporting.allIncidentsInternal.filters.confirmationDate'
      )}
      ranges={getDefaultDateRanges()}
      rangePicker
      onChange={handlerSetConfirmationDate}
      value={confirmationDate || undefined}
    />
  );
};

const mapStateToProps = state => {
  return {
    confirmationDate: getAllIncidentsFiltersConfirmationDate(state),
  };
};

export default connect(mapStateToProps, {
  allIncidentsFiltersSetConfirmationDate,
})(AllIncidentsFiltersConfirmationDate);
